export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOG_OUT = 'LOG_OUT'
export const LOAD_PROFILE = 'LOAD_PROFILE'


export const HOME_VIDEOS_SUCCESS = 'HOME_VIDEOS_SUCCESS'
export const HOME_VIDEOS_FAIL = 'HOME_VIDEOS_FAIL'
export const HOME_VIDEOS_REQUEST = 'HOME_VIDEOS_REQUEST'


export const SELECTED_VIDEO_REQUEST = 'SELECTED_VIDEO_REQUEST'
export const SELECTED_VIDEO_SUCCESS = 'SELECTED_VIDEO_SUCCESS'
export const SELECTED_VIDEO_FAIL = 'SELECTED_VIDEO_FAIL'

export const CHANNEL_DETAILS_REQUEST = 'CHANNEL_DETAILS_REQUEST'
export const CHANNEL_DETAILS_SUCCESS = 'CHANNEL_DETAILS_SUCCESS'
export const CHANNEL_DETAILS_FAIL = 'CHANNEL_DETAILS_FAIL'

export const SET_SUBSCRIPTION_STATUS = 'SET_SUBSCRIPTION_STATUS'
export const SET_SUBSCRIPTION_FAIL = 'SET_SUBSCRIPTION_FAIL'

export const COMMENT_LIST_REQUEST = 'COMMENT_LIST_REQUEST'
export const COMMENT_LIST_SUCCESS = 'COMMENT_LIST_SUCCESS'
export const COMMENT_LIST_FAIL = 'COMMENT_LIST_FAIL'

export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS'
export const CREATE_COMMENT_FAIL = 'CREATE_COMMENT_FAIL'

export const RELATED_VIDEOS_REQUEST = 'RELATED_VIDEOS_REQUEST'
export const RELATED_VIDEOS_SUCCESS = 'RELATED_VIDEOS_SUCCESS'
export const RELATED_VIDEOS_FAIL = 'RELATED_VIDEOS_FAIL'

export const SEARCH_VIDEOS_REQUEST = 'SEARCH_VIDEOS_REQUEST'
export const SEARCH_VIDEOS_SUCCESS = 'SEARCH_VIDEOS_SUCCESS'
export const SEARCH_VIDEOS_FAIL = 'SEARCH_VIDEOS_FAIL'

export const SUBSCRIPTIONS_CHANNEL_REQUEST = 'SUBSCRIPTIONS_CHANNEL_REQUEST'
export const SUBSCRIPTIONS_CHANNEL_SUCCESS = 'SUBSCRIPTIONS_CHANNEL_SUCCESS'
export const SUBSCRIPTIONS_CHANNEL_FAIL = 'SUBSCRIPTIONS_CHANNEL_FAIL'

export const CHANNELS_VIDEOS_REQUEST = 'CHANNELS_VIDEOS_REQUEST'
export const CHANNELS_VIDEOS_SUCCESS = 'CHANNELS_VIDEOS_SUCCESS'
export const CHANNELS_VIDEOS_FAIL = 'CHANNELS_VIDEOS_FAIL'